import { Store } from '@ngrx/store';
import { FolderOperationDropdownOption } from 'FoldersApp/enums/folder-operation-dropdown-option.enum';
import { FolderableType } from 'FoldersApp/enums/folderable-type.enum';
// Actions
import { setSelectedFolderableOperation } from 'FoldersApp/state/selected-folder-item/selected-folderable-operation.action';
import { getSharingButtonConfig } from 'SharingApp/ts/utils/public-sharing-utils';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i3 from "../../../../../../ycharts/static/ts/features/components/dropdowns/simple-dropdown/simple-dropdown.component";
export class FolderOperationsDropdownComponent {
    get showDropdownCaret() {
        return !this.listItemView;
    }
    get buttonClass() {
        return this.listItemView ? 'btn btn-secondary arrow-down' : '';
    }
    get icon() {
        return this.listItemView ? 'icon-dots-more' : '';
    }
    get folderDropdownConfig() {
        const shareOption = {
            type: 'option',
            label: 'Share',
            value: FolderOperationDropdownOption.SHARE,
            icon: 'icon-share',
            disabled: !this.item.permissions?.canShare,
        };
        const { label, disabled } = getSharingButtonConfig(shareOption, {
            id: this.item.id || 0,
            name: this.item.name,
            sharing: this.item.sharing,
            item_type: this.resourceType,
            item_type_description: this.resourceTypeDescription,
        }, this.item.permissions?.canShare || false);
        shareOption.label = label;
        shareOption.disabled = disabled;
        return {
            title: {
                label: '',
                icon: this.icon,
            },
            list: [
                shareOption,
                {
                    type: 'option',
                    label: 'Rename',
                    value: FolderOperationDropdownOption.RENAME,
                    icon: 'icon-edit',
                    disabled: !this.item.permissions?.canRename,
                },
                {
                    type: 'option',
                    label: 'Move',
                    value: FolderOperationDropdownOption.MOVE,
                    icon: 'icon-folder-move',
                    disabled: !this.item.permissions?.canMove,
                },
                {
                    type: 'option',
                    label: 'Delete',
                    value: FolderOperationDropdownOption.DELETE,
                    icon: 'icon-delete',
                    disabled: !this.item.permissions?.canDelete,
                },
            ],
        };
    }
    get relativePositionedElemId() {
        return `folder-operations-dropdown-${this.resourceType}-${this.item.id}`;
    }
    constructor(store) {
        this.store = store;
        this.listItemView = false;
    }
    folderDropdownHandler(operationName) {
        if (this.item.id === null)
            throw new Error('No item selected');
        if (!Object.values(FolderOperationDropdownOption).includes(operationName)) {
            throw new Error(`Invalid operation name: ${operationName}`);
        }
        const selectedOperation = {
            item: {
                id: this.item.id,
                name: this.item.name,
                itemType: this.resourceType,
                itemTypeDescription: this.resourceTypeDescription || '',
                ancestorFolderId: this.ancestorFolderId,
                relativePositionedElemId: this.relativePositionedElemId,
                sharing: this.item.sharing,
            },
            operation: operationName,
        };
        this.store.dispatch(setSelectedFolderableOperation({ selectedOperation }));
    }
}
FolderOperationsDropdownComponent.ɵfac = function FolderOperationsDropdownComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderOperationsDropdownComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
FolderOperationsDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FolderOperationsDropdownComponent, selectors: [["ycn-folder-operations-dropdown"]], inputs: { item: "item", resourceType: "resourceType", resourceTypeDescription: "resourceTypeDescription", ancestorFolderId: "ancestorFolderId", folderIsDisabled: "folderIsDisabled", listItemView: "listItemView" }, standalone: false, decls: 1, vars: 8, consts: [["ycnTooltip", "", 1, "dropdown", 3, "handler", "id", "inputDisabled", "tooltipTitle", "tooltipPlacement", "buttonClass", "config", "dropdownClass", "showDropdownCaret"]], template: function FolderOperationsDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-simple-dropdown", 0);
        i0.ɵɵlistener("handler", function FolderOperationsDropdownComponent_Template_ycn_simple_dropdown_handler_0_listener($event) { return ctx.folderDropdownHandler($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("id", ctx.relativePositionedElemId)("inputDisabled", ctx.folderIsDisabled)("tooltipTitle", "More Options")("tooltipPlacement", "bottom")("buttonClass", ctx.buttonClass)("config", ctx.folderDropdownConfig)("dropdownClass", "dropdown-menu-right dropdown-menu-with-icons")("showDropdownCaret", ctx.showDropdownCaret);
    } }, dependencies: [i2.TooltipDirective, i3.SimpleDropdownComponent], encapsulation: 2, changeDetection: 0 });
